import printReportAction from '@/components/nsw-components/PrintReportsAction';
import DocumentNewVersionAction from '@/components/nsw-components/DocumentNewVersionAction';

export default {
	actions: [
		printReportAction.printReport('EFFECT_DECLARATION', 'imofalformid', 'reports.label.falForms.effectDeclaration'),
		DocumentNewVersionAction.newVersion({
			imofalformtypeid: 4
		})
	]
};
